import { isPointDistribution } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import {
    selectFactById,
    selectIgnoreRemainingsByOrderId,
    selectInventoryListById,
    selectPlanById,
    selectPointDebtsByPointId,
    selectPointInventoryById,
    selectPriceListById,
    selectPriceListIdById,
    selectPromosById,
    selectPromosVocabularyById,
} from "@/store/slices/offline";
import { selectPointById } from "@/store/slices/work";

export const usePointPriceListSelector = (pointId: string) =>
    useAppSelector((state) => {
        const priceListId = selectPriceListIdById(state, pointId);

        return selectPriceListById(state, priceListId ?? "");
    });

export const usePointPlanSelector = (pointId: string) =>
    useAppSelector((state) => selectPlanById(state, pointId));

export const useStorageInventorySelector = (storageId: string) =>
    useAppSelector((state) => selectInventoryListById(state, storageId));

export const usePointInventorySelector = (pointId: string) =>
    useAppSelector((state) => selectPointInventoryById(state, pointId));

export const usePointFactSelector = (pointId: string) =>
    useAppSelector((state) => selectFactById(state, pointId));

export const useOfflineModeSelector = () =>
    useAppSelector((state) => state.offline.offlineMode);

export const useIgnoreRemainingsSelector = (orderId: string) =>
    useAppSelector((state) => selectIgnoreRemainingsByOrderId(state, orderId));

export const usePointPromosSelector = (pointId: string) =>
    useAppSelector((state) => {
        const point = selectPointById(state, pointId);

        const clientId =
            point && isPointDistribution(point)
                ? point.typeContext.client.id
                : "";

        const pointPromoKey =
            selectPromosVocabularyById(state, pointId) ??
            selectPromosVocabularyById(state, clientId);

        return selectPromosById(state, pointPromoKey ?? "");
    });

export const usePointDebtsSelector = (pointId: string) =>
    useAppSelector((state) => selectPointDebtsByPointId(state, pointId));
